import _ from "lodash";
import { InverseOf, ValueOf } from "../../utils/type-functions";

export const questionnariesTabsMap = {
  'anamnese': 'anamnesis',
  'evolução': 'evolution',
  'toxicidade': 'toxicity',
  'sinais vitais': 'vitalSigns',
  'exame físico': 'physicalExam',
  'conduta': 'conduct',
  'educação': 'education',
  'enfermagem': 'nursingHistory',
  'farmácia': 'pharmacy',
  'ram': 'ram',
  'nutrição': 'nutrition',
  'psicologia': 'psychologyAssessment'
} as const;

export const otherTabsMap = {
  'quimioterapia': 'chemotherapy',
  'diagnóstico': 'diagnosis',
  'requisições': 'requests',
  'comorbidades': 'allergiesComorbities',
} as const;

export const allMedicalTabsMap = {
  ...questionnariesTabsMap,
  ...otherTabsMap
}

export const typeNameToTabNameMap = {
  ..._.invert(allMedicalTabsMap) as InverseOf<typeof allMedicalTabsMap>,
  'nursing': 'enfermagem' as const,
  'nursingHistory': 'enfermagem' as const,
  'nursingAvaliation': 'enfermagem' as const,
  'nursingDiagnostic': 'enfermagem' as const,
  'pharmacy': 'farmácia' as const,
  'pharmacyIntervention': 'farmácia' as const,
  'pharmacyAttention': 'farmácia' as const,
  'psychology': 'psicologia' as const,
  'psychologyBackground': 'psicologia' as const,
  'psychologyEvolution': 'psicologia' as const,
  'psychologyDistress': 'psicologia' as const,
  'allergiesComorbidities': 'comorbidades' as const

} as const


export type QuestionnariesTabs = typeof questionnariesTabsMap[keyof typeof questionnariesTabsMap];
export type QuestionnariesTabsNames = keyof typeof questionnariesTabsMap;
export type OtherTabsNames = keyof typeof otherTabsMap;
export const questionnariesTabsNames: QuestionnariesTabsNames[] = Object.keys(questionnariesTabsMap) as QuestionnariesTabsNames[];

export const medicalTabs = [
  'diagnóstico',
  'anamnese',
  'evolução',
  'exame físico',
  'sinais vitais',
  'comorbidades',
  'toxicidade',
  'requisições',
  'conduta',
  'enfermagem',
  'farmácia',
  'ram',
  'nutrição',
  'psicologia',
  'educação',
  'quimioterapia'
] as const

export type MedicalTab = (typeof medicalTabs)[number]

